/**
 * LUSH Variant Consolidator
 * Handles dynamic switching between product variants in consolidated PDPs
 */

class VariantConsolidator {
  constructor() {
    this.currentVariant = null;
    this.variantProducts = [];
    this.init();
  }

  init() {
    if (document.querySelector('.consolidated-variants')) {
      this.setupVariantButtons();
      this.setupFormHandling();
    }
  }

  setupVariantButtons() {
    const variantButtons = document.querySelectorAll('.variant-option');
    
    variantButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchVariant(button);
      });
    });
  }

  switchVariant(button) {
    // Remove active class from all buttons
    document.querySelectorAll('.variant-option').forEach(btn => {
      btn.classList.remove('active');
    });

    // Add active class to clicked button
    button.classList.add('active');

    // Get variant data
    const variantId = button.getAttribute('data-variant-id');
    const price = button.getAttribute('data-price');
    const weight = button.getAttribute('data-weight');
    const productHandle = button.getAttribute('data-product-handle');

    // Update price display
    const priceField = document.querySelector('.price-field.regprice');
    if (priceField) {
      priceField.textContent = price;
    }

    // Update variant selection dropdown
    const sizeSelect = document.querySelector('.size-select');
    if (sizeSelect) {
      sizeSelect.value = variantId;
    }

    // Update add to cart button
    const addToCartButton = document.querySelector('#unique-cart-btn');
    if (addToCartButton) {
      addToCartButton.value = variantId;
    }

    // Update form action to point to correct product
    const form = document.querySelector('.add-to-cart');
    if (form && productHandle) {
      form.setAttribute('action', `/cart/add`);
      form.setAttribute('data-productid', variantId);
    }

    // Update inventory display
    this.updateInventoryDisplay(variantId);

    // Trigger any existing theme variant change handlers
    this.triggerVariantChange(variantId);
  }

  updateInventoryDisplay(variantId) {
    // Find the variant option and get its inventory data
    const variantButton = document.querySelector(`[data-variant-id="${variantId}"]`);
    if (variantButton) {
      const stockQty = variantButton.getAttribute('data-stockqty');
      const inventoryField = document.querySelector('.variant-inventory');
      if (inventoryField && stockQty) {
        inventoryField.value = stockQty;
        inventoryField.setAttribute('data-FirstItemId', variantId);
        inventoryField.setAttribute('data-firstQty', stockQty);
      }
    }
  }

  triggerVariantChange(variantId) {
    // Trigger custom event for theme compatibility
    const event = new CustomEvent('variant:changed', {
      detail: { variantId: variantId }
    });
    document.dispatchEvent(event);

    // Also trigger change event on size select if it exists
    const sizeSelect = document.querySelector('.size-select');
    if (sizeSelect) {
      sizeSelect.dispatchEvent(new Event('change'));
    }
  }

  setupFormHandling() {
    const form = document.querySelector('.add-to-cart');
    if (form) {
      form.addEventListener('submit', (e) => {
        // Ensure the correct variant is being added
        const activeButton = document.querySelector('.variant-option.active');
        if (activeButton) {
          const variantId = activeButton.getAttribute('data-variant-id');
          const idInput = form.querySelector('input[name="id"]');
          if (idInput) {
            idInput.value = variantId;
          }
        }
      });
    }
  }

  // Method to get current variant info
  getCurrentVariant() {
    const activeButton = document.querySelector('.variant-option.active');
    if (activeButton) {
      return {
        id: activeButton.getAttribute('data-variant-id'),
        price: activeButton.getAttribute('data-price'),
        weight: activeButton.getAttribute('data-weight'),
        productHandle: activeButton.getAttribute('data-product-handle')
      };
    }
    return null;
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  window.variantConsolidator = new VariantConsolidator();
});

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = VariantConsolidator;
} 